export * from "./typography-component";
